import { createAction } from '../../store.model';
import { User, UserHierarchy } from '../../user/user.model';
import { PeriodType } from '../../widget/date-range.widget.model';

import { PerformerOa } from './performer-oa.model';

export enum ActionType {
    COACHING_DETAIL__P1__SELECT_METRIC = 'COACHING_DETAIL__P1__SELECT_METRIC',
    COACHING_DETAIL__P1__RELOAD = 'COACHING_DETAIL__P1__RELOAD',
    COACHING_DETAIL__P1__RELOAD_RESULT = 'COACHING_DETAIL__P1__RELOAD_RESULT',
    COACHING_DETAIL__P1__RELOAD_CANCEL = 'COACHING_DETAIL__P1__RELOAD_CANCEL',
    COACHING_DETAIL__P1__RELOAD_USER = 'COACHING_DETAIL__P1__RELOAD_USER',
    COACHING_DETAIL__P1__RELOAD_USER_RESULT = 'COACHING_DETAIL__P1__RELOAD_USER_RESULT',
    COACHING_DETAIL__P1__RELOAD_USER_CANCEL = 'COACHING_DETAIL__P1__RELOAD_CANCEL',
}

export interface SelectMetric {
    /** set to undefined when is nonKpi */
    metricId: number;

    /** commitmentId. set to undefined when metricId is known */
    nonKpiId: number;
}

export const selectMetric = createAction<ActionType, SelectMetric>(
    ActionType.COACHING_DETAIL__P1__SELECT_METRIC,
);

/// ///////

export interface Reload {
    userId: number;
    periodTypeId: PeriodType;
    isNonKpi: boolean;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_DETAIL__P1__RELOAD,
);

export interface ReloadResult extends Reload {
    performerOa?: PerformerOa;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_DETAIL__P1__RELOAD_RESULT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ReloadCancel {}

export const reloadCancel = createAction<ActionType, ReloadCancel>(
    ActionType.COACHING_DETAIL__P1__RELOAD_CANCEL,
);

/// ///////

export interface ReloadUser {
    userId: number;
}

export const reloadUser = createAction<ActionType, ReloadUser>(
    ActionType.COACHING_DETAIL__P1__RELOAD_USER,
);

export interface ReloadUserResult extends ReloadUser {
    user?: User;
    userManager?: UserHierarchy;
}

export const reloadUserResult = createAction<ActionType, ReloadUserResult>(
    ActionType.COACHING_DETAIL__P1__RELOAD_USER_RESULT,
);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ReloadUserCancel {}

export const reloadUserCancel = createAction<ActionType, ReloadUserCancel>(
    ActionType.COACHING_DETAIL__P1__RELOAD_USER_CANCEL,
);
